module.exports = __webpack_public_path__ + "img/P3-zh.d2d98a74.png";